const LiveSearchAnalytics = (analyticsEvent, analyticsWriterId, analyticsFilterChanged) => {
  const results = JSON.parse(document.getElementById(analyticsWriterId).dataset.searchListings)
  const filters = JSON.parse(document.getElementById(analyticsWriterId).dataset.queryParams)
  const bounds = document.getElementById(analyticsWriterId).dataset.mapBounds
  const center = document.getElementById(analyticsWriterId).dataset.mapCenter
  const radius = document.getElementById(analyticsWriterId).dataset.mapRadius

  let eventName = ''

  // Segment thinks the field "name" is a person's name, so it adds asterisks for anonimity and removes nulls
  // But this isn't a person's name, it's the name of a child care business the user is searching for
  // So, we rename the field "name" to "child_care_provider_name" so that Segment will treat it normally
  filters.child_care_provider_name = filters.name || null
  delete filters.name

  //  Then we rename "location" to "child_care_provider_location" so that the data team understands that both fields are similar
  //  i.e. the location you're searching for and the name of a business you're searching for
  filters.child_care_provider_location = filters.location || null
  delete filters.location

  const payload = {
    filters,
    numberOfResults: results.length || null,
    top24SchoolResults: results.slice(0, 24) || null,
    mapBounds: bounds || null,
    mapCenter: center || null,
    mapRadius: radius || null,
  }

  if (analyticsEvent === 'filterUpdated') {
    eventName = 'Live search page inputs and results'
    payload.filterChanged = analyticsFilterChanged
  }

  if (analyticsEvent === 'pageLoad') {
    eventName = 'Live search page inputs and results'
    payload.filterChanged = 'none-initial-page-load'
  }

  if (analyticsEvent === 'mapUpdated') {
    eventName = 'Live search page map moved'
  }

  //   Send event to Segment and remove the variables from local storage
  window.analytics.track(`[BEHAVIOR] ${eventName}`, payload)
  localStorage.removeItem('analyticsEvent')
  localStorage.removeItem('analyticsFilterChanged')
  localStorage.removeItem('analyticsElemId')
}

export default LiveSearchAnalytics
